import * as React from "react"

function SvgSocialMediaGoogle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      {...props}
    >
      <path
        d="M10 19.583A9.583 9.583 0 01.417 10a9.583 9.583 0 0116.57-6.56l-2.43 2.282A6.197 6.197 0 0010 3.75a6.25 6.25 0 105.906 8.333H11.25V8.75h8.333v1.75A9.584 9.584 0 0110 19.583zM4.583 6.833L1.957 4.732M4.65 13.19l-2.527 2.275m11.603-.441l2.225 2.504"
        fill="none"
        fillRule="evenodd"
        stroke="#FFFCFC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.833}
      />
    </svg>
  )
}

export default SvgSocialMediaGoogle
